var loadAjax = true;

$(function() {
    if($('#product-line').length > 0) {
        loadProducts({
            page: 0
        });

        window.onscroll = function() {
            var $bodyContanier = $('#productLineList'),
                totalsProducts = parseInt($bodyContanier.data('count')),
                currentCount = parseInt($bodyContanier.data('currentCount'));
            if ($bodyContanier.offset() && ($(window).scrollTop() + $(window).height() > $bodyContanier.offset().top + $bodyContanier.height() - 100) && loadAjax) {
                if(currentCount != totalsProducts && currentCount < totalsProducts) {
                    $bodyContanier.append("<div class='col-xs-12 spinner-block'><div class='spinner spinner--brand spinner--md lazy-load' role='status'><span class='sr-only'>Loading...</span></div></div>");               
                    loadAjax = false;
                    loadProducts({
                        page: parseInt($('#productLineList').data('currentPage'))
                    });
                }
            }
        };
    }
});

function loadProducts(args) {
    const $bodyContanier = $('#productLineList'),
        currentPage = $bodyContanier.data('currentPage'),
        currentProducts = $bodyContanier.data('currentCount'),
        sortCode = $bodyContanier.data('sort'),
        category = $bodyContanier.data('category');
    args.sort = sortCode;
    $.ajax({
        url: contextPath+ '/pl/'+ category,
        method: 'POST',
        data: args,
        success: function(result) {
            const products = result.searchPageData.results,
                productCount = parseInt(currentProducts) + products.length;

            $bodyContanier.data('currentPage', parseInt(currentPage) + 1);
            $bodyContanier.data('currentCount', productCount);

            if(args.page == 0) {
             $("#productLineList").empty();
            }

            $bodyContanier.append($("#productLineTemplate").tmpl({data: products, productCount: productCount, currentProducts: currentProducts}));
            $bodyContanier.find('.spinner-block').remove();

            bindWishlistIconClick();
            bindWishlistIcons();
        },
        complete: function() {
            loadAjax = true;
            $('[data-toggle="tooltip"]').tooltip();
            ACC.product.bindToAddToCartForm();
        }
    })
    
}